(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-vo-finder]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const cards = [...root.querySelectorAll('[data-vo-card]')];
      const sliders = [...root.querySelectorAll('[data-vo-trait]')];
      const tabs = [...root.querySelectorAll('[data-vo-category]')];
      const more = root.querySelector('[data-vo-more]');
      const defaultCategory = root.dataset.defaultCategory || 'all';
      const pageSize = Math.max(1, Math.min(24, Number(root.dataset.visibleStyles) || 8));
      const allowMore = root.dataset.allowMore !== 'false';
      let category = defaultCategory, limit = pageSize;
      function update() {
        const matches = cards.filter(card => (category === 'all' || card.dataset.category === category) && sliders.every(input => {
          const desired = Number(input.value), score = Number(card.dataset[input.dataset.voTrait]);
          return !desired || (score > 0 && (input.dataset.voTrait === 'popularity' ? score >= desired : Math.abs(score - desired) <= 1));
        }));
        const visible = matches.slice(0, limit);
        cards.forEach(card => { card.hidden = !visible.includes(card); });
        sliders.forEach(input => {
          const value = Number(input.value);
          const label = value ? (input.dataset.voTrait === 'popularity' ? `${value}+ / 5` : `${value} / 5`) : 'Any';
          root.querySelector(`[data-vo-output="${input.dataset.voTrait}"]`).textContent = label;
          input.setAttribute('aria-valuetext', value ? (input.dataset.voTrait === 'popularity' ? `At least ${value} out of 5` : `Around ${value} out of 5`) : 'Any');
          input.style.setProperty('--vo-progress', `${value * 20}%`);
        });
        tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.voCategory === category)));
        root.querySelector('[data-vo-count]').textContent = `${matches.length} ${matches.length === 1 ? 'style' : 'styles'} in your edit${matches.length > limit ? ` · showing ${visible.length}` : ''}`;
        root.querySelector('[data-vo-empty]').hidden = matches.length > 0;
        more.hidden = !allowMore || matches.length <= limit;
      }
      sliders.forEach(input => input.addEventListener('input', () => { limit = pageSize; update(); }));
      tabs.forEach(tab => tab.addEventListener('click', () => { category = tab.dataset.voCategory; limit = pageSize; update(); }));
      root.querySelectorAll('[data-vo-reset]').forEach(button => button.addEventListener('click', () => { sliders.forEach(input => input.value = '0'); category = defaultCategory; limit = pageSize; update(); }));
      more.addEventListener('click', () => {
        const previousLimit = limit;
        if (!allowMore) return;
        limit += pageSize; update();
        const shown = cards.filter(card => !card.hidden);
        shown[previousLimit]?.querySelector('a')?.focus({preventScroll:true});
      });
      root.querySelector('[data-vo-controls]').hidden = false;
      update();
      if(root.dataset.ratingsUrl){
        window.voSharedRatingsPromise ||= fetch(root.dataset.ratingsUrl).then(r=>{if(!r.ok)throw new Error();return r.json();}).catch(()=>null);
        window.voSharedRatingsPromise.then(data=>{if(!data?.products)return;const scores=new Map(data.products.map(p=>[p.id,p]));cards.forEach(card=>{const p=scores.get(card.dataset.productId);if(!p)return;['drama','wispiness','popularity'].forEach(key=>{if(Number.isInteger(p[key])&&p[key]>=0&&p[key]<=5)card.dataset[key]=p[key];});const profile=card.querySelector('.vo-style-card__profile');if(profile){profile.replaceChildren();for(const [key,label] of [['drama','Drama'],['wispiness','Wispy']]){if(p[key]>0){const span=document.createElement('span');span.textContent=label+' '+p[key]+'/5';profile.append(span);}}}});update();});
      }
    });
    scope.querySelectorAll('[data-vo-ticker-toggle]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const ticker = button.closest('.vl-marquee');
        const paused = ticker.dataset.voPaused !== 'true';
        ticker.dataset.voPaused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Play ticker' : 'Pause ticker';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

// Native scroll rails work with touch, keyboard and optional arrow controls.
(() => {
  function rails(scope = document) {
    scope.querySelectorAll('[data-vo-rail]').forEach(rail => {
      if (rail.dataset.voRailReady) return;
      const track = rail.querySelector('[data-vo-track]');
      if (!track) return;
      rail.dataset.voRailReady = 'true';
      for (const [selector, direction] of [['[data-vo-prev]', -1], ['[data-vo-next]', 1]]) {
        rail.querySelector(selector)?.addEventListener('click', () => {
          track.scrollBy({left: direction * track.clientWidth * .82, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => rails());
  else rails();
  document.addEventListener('shopify:section:load', event => rails(event.target));
})();

// Quick-add cards use the existing theme cart drawer, including its totals and app widgets.
(function () {
  var pending = new WeakSet();
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var button = form.querySelector('button.vo-card-cta[type="submit"]');
    if (!button || !document.getElementById('sidebar-cart')) return;
    var endpoint = new URL(form.action, window.location.href);
    if (endpoint.origin !== window.location.origin || !/\/cart\/add\/?$/.test(endpoint.pathname)) return;
    if (event.defaultPrevented) return;
    event.preventDefault();
    if (pending.has(form)) return;

    var body = new FormData(form);
    var quantity = Math.max(1, parseInt(body.get('quantity'), 10) || 1);
    var status = form.querySelector('[data-vo-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-vo-cart-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.cssText = 'margin:8px 0 0;font-size:14px;line-height:1.4;';
      form.appendChild(status);
    }
    status.hidden = true;
    status.textContent = '';
    pending.add(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    try {
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
      var response = await fetch(endpoint.href, {
        method: 'POST', credentials: 'same-origin', body: body,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      var item = await response.json();
      if (!response.ok) throw new Error(item.description || item.message || 'This item could not be added. Please try again.');
      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true, detail: { variant: item, quantity: quantity }
      }));
    } catch (error) {
      status.textContent = error instanceof TypeError
        ? 'We could not confirm the update. Check your cart before trying again.'
        : (error.message || 'This item could not be added. Please try again.');
      status.hidden = false;
    } finally {
      pending.delete(form);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  });
})();
